module.exports = __webpack_public_path__ + "img/tu01.7a7451dc.jpg";